import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../../../shared/shared/shared.module';
import { CountryCodeService } from '../../../services/country-code/country-code.service';
import { BlKeywordAddBlKeywordModalModule } from './bl-keyword-add-modal/bl-keyword-add-bl-keyword-modal.module';
import { BlKeywordSearchComponent } from './bl-keyword-search/bl-keyword-search.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    BlKeywordAddBlKeywordModalModule,
  ],
  providers: [
    CountryCodeService,
  ],
  declarations: [
    BlKeywordSearchComponent
  ]
})
export class BlKeywordSearchModule {
}
